import { useApiClient } from './apiClient';
import { ApiRoutes } from '@/constants/apiConstants';
import type { NotificationResponse, NotificationAdminResponse } from '@/types/notification';

class NotificationService {
  async getUnreadNotifications(): Promise<NotificationResponse[]> {
    const response = await (await useApiClient()).apiClient
      .get<NotificationResponse[]>(ApiRoutes.Notification.GetUnreadNotifications) as unknown as NotificationResponse[];
    return response;
  }

  async markAsRead(notificationId: number): Promise<void> {
    await (await useApiClient()).apiClient
      .post<void>(ApiRoutes.Notification.MarkAsRead, notificationId);
  }

  // Admin methods
  async getAllNotifications(filters?: {
    userId?: number;
    isSent?: boolean;
    isRead?: boolean;
    isAbandoned?: boolean;
    relatedBookingId?: number;
  }): Promise<NotificationAdminResponse[]> {
    const params = new URLSearchParams();
    if (filters?.userId !== undefined) params.append('userId', filters.userId.toString());
    if (filters?.isSent !== undefined) params.append('isSent', filters.isSent.toString());
    if (filters?.isRead !== undefined) params.append('isRead', filters.isRead.toString());
    if (filters?.isAbandoned !== undefined) params.append('isAbandoned', filters.isAbandoned.toString());
    if (filters?.relatedBookingId !== undefined) params.append('relatedBookingId', filters.relatedBookingId.toString());

    const queryString = params.toString();
    const url = `${ApiRoutes.Notification.GetAllNotifications}${queryString ? `?${queryString}` : ''}`;
    
    const response = await (await useApiClient()).apiClient
      .get<NotificationAdminResponse[]>(url) as unknown as NotificationAdminResponse[];
    return response;
  }

  async resendNotification(notificationId: number): Promise<{ success: boolean; message: string }> {
    const response = await (await useApiClient()).apiClient
      .post<{ success: boolean; message: string }>(ApiRoutes.Notification.ResendNotification, notificationId) as unknown as { success: boolean; message: string };
    return response;
  }
}

export default new NotificationService();
